import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { FormatAmount } from '../FormatAmount';

function createRows(data) {
    return data.map(item => ({
        name: item?.category,
        today: item?.today,
        mtd: item?.mtd,
        ytd: item?.ytd,
        mtdPercentage: item?.mtdPercentage,
        ytdPercentage: item?.ytdPercentage,
        total: item?.total,
        totalPercentage: item?.totalPercentage,
    }));
}
export default function PurchaseOrderCompilance({filter, fetchedData, purchaseOrderCompilance}) {

    const [listPayable, setListPayable] = useState([])

    useEffect(() => {
        setListPayable(purchaseOrderCompilance);
    }, [purchaseOrderCompilance]);
    // useEffect(() => {
    //   if(fetchedData){
    //       fetchData();
    //   }
    // }, [fetchedData]);

    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardPurchaseOrderComp?Month=${filter?.month}&Year=${filter?.year}`, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    //             },

    //         })
    //         console.log("response", response?.data?.response);
    //         setListPayable(response?.data?.response)
    //     } catch (error) {
    //         console.log("error", error);
    //     }
    // }

    const rows = createRows(listPayable);



    const chartOptionsMTD = {
        labels: ['Po Based', 'Non-PO Based'],
        colors: ['#FEBC3B', '#031C30'],

    };

    const chartSeriesMTD = [parseFloat(rows[0]?.mtd), parseFloat(rows[1]?.mtd)];
    console.log("chartSeriesMTD", chartSeriesMTD);
    const chartOptionsYTD = {
        labels: ['Po Based', 'Non-PO Based'],
        colors: ['#FEBC3B', '#031C30'],

    };

    const chartSeriesYTD = [parseFloat(rows[0]?.ytd), parseFloat(rows[1]?.ytd)];
    console.log("chartSeriesYTD", chartSeriesYTD);
    const chartOptionsTotal = {
        labels: ['Po Based', 'Non-PO Based'],
        colors: ['#FEBC3B', '#031C30'],

    };

    const chartSeriesTotal = [parseFloat(rows[0]?.total), parseFloat(rows[1]?.total)];
    console.log("chartSeriesTotal", chartSeriesTotal);

    return (
        <div>
            <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                            <TableCell style={{ color: "black", fontWeight: 600, width: "150px" }}>Name</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">MTD</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">% age</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">YTD</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">% age</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">SELECTED DATE DATA</TableCell>
                            <TableCell style={{ color: "black", fontWeight: 600 }} align="right">% age</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow
                                key={row.name}
                                sx={{
                                    '&:last-child td': {
                                        fontWeight: index === rows.length - 1 ? 'bold' : 'normal',
                                    },
                                }}
                            >
                                <TableCell component="th" scope="row" style={{ fontWeight: row.name === 'Total' ? 'bold' : 'normal' }}>
                                    {row.name}
                                </TableCell>
                                <TableCell align="right">{FormatAmount(row?.mtd)}</TableCell>
                                <TableCell align="right">{FormatAmount(row?.mtdPercentage)} %</TableCell>
                                <TableCell align="right">{FormatAmount(row?.ytd)}</TableCell>
                                <TableCell align="right">{FormatAmount(row?.ytdPercentage)}%</TableCell>
                                <TableCell align="right">{FormatAmount(row?.total)}</TableCell>
                                <TableCell align="right">{FormatAmount(row?.totalPercentage)}%</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div style={{
                display: "flex",
                gap: "10px",
                overflowX: "auto",
                whiteSpace: "nowrap",
                paddingBottom: "10px",
                marginLeft: "120px",
            }}>
                <div
                    style={{
                        flex: "0 0 auto",
                        width: "250px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center", // ← CENTER label + chart
                    }}
                >
                    <p style={{ color: "black", fontSize: 14, fontWeight: "bold", textAlign: "center" }}>
                        Payment On Time (MTD)
                    </p>

                    <ReactApexChart
                        options={chartOptionsMTD}
                        series={chartSeriesMTD}
                        type="pie"
                        width="100%"
                    />
                </div>

                <div
                    style={{
                        flex: "0 0 auto",
                        width: "250px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center", // ← CENTER label + chart
                    }}
                >
                    <p style={{ color: "black", fontSize: 14, fontWeight: "bold", textAlign: "center" }}>
                        Payment On Time (YTD)
                    </p>

                    <ReactApexChart
                        options={chartOptionsYTD}
                        series={chartSeriesYTD}
                        type="pie"
                        width="100%"
                    />
                </div>

                <div
                    style={{
                        flex: "0 0 auto",
                        width: "250px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center", // ← CENTER label + chart
                    }}
                >
                    <p style={{ color: "black", fontSize: 14, fontWeight: "bold", textAlign: "center" }}>
                        Payment On Time (SELECTED DATE)
                    </p>

                    <ReactApexChart
                        options={chartOptionsTotal}
                        series={chartSeriesTotal}
                        type="pie"
                        width="100%"
                    />
                </div>

            </div>
        </div>
    );
}
